import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileCf"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 8.25V6.75H12.75V17.25H14.25V12.75H18V11.25H14.25V8.25H18.75ZM11.25 17.25H6.75C5.92157 17.25 5.25 16.5784 5.25 15.75V8.25C5.25 7.42157 5.92157 6.75 6.75 6.75H11.25V8.25H6.75V15.75H11.25V17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileCf.vue"]]);
